import { GetSubjectLecturersArgs } from '@modules/timetable';
import { TimelineItemTypeType } from '@app-types/timetable';
import { subjects_for_timetableQuery } from '@app-types/graphql-types';

export const getSubjectLecturers = ({
  selectedDraggableItem,
  batchSubjects,
  timelineItemId,
  itemType,
}: GetSubjectLecturersArgs) => {
  let subjectLecturers:
    | subjects_for_timetableQuery['batch_subject_configuration'][0]['subject']['subject_to_users']
    | undefined;

  if (timelineItemId) {
    if (itemType === TimelineItemTypeType.subject) {
      subjectLecturers = batchSubjects?.find((batchSubject) => batchSubject.id === timelineItemId)?.subject
        ?.subject_to_users;
    } else if (itemType === TimelineItemTypeType.extra) {
      // If subject extra id found inside batchSubjects return subject lecturers list
      subjectLecturers = batchSubjects.find((batchSubject) => {
        const containsExtraSlot = batchSubject.batch_subject_extra_slots.find(
          (extraSlot) => extraSlot.id === timelineItemId,
        );

        return Boolean(containsExtraSlot);
      })?.subject?.subject_to_users;
    }
  } else if (selectedDraggableItem?.split('/')[0] === 'subject') {
    subjectLecturers = batchSubjects?.find((batchSubject) => batchSubject.id === selectedDraggableItem?.split('/')[1])
      ?.subject?.subject_to_users;
  } else if (selectedDraggableItem?.split('/')[0] === 'extra') {
    // If subject extra id found inside batchSubjects return subject lecturers list
    subjectLecturers = batchSubjects.find((batchSubject) => {
      const containsExtraSlot = batchSubject.batch_subject_extra_slots.find(
        (extraSlot) => extraSlot.id === selectedDraggableItem?.split('/')[1],
      );

      return Boolean(containsExtraSlot);
    })?.subject?.subject_to_users;
  }

  return subjectLecturers;
};
